import { NotificationDto } from '@interfaces/models';
import { cn } from '@ui/utils';
import React from 'react';

import { NotificationsListItem } from './dashboard-notifications-list-item';

interface DashboardNotificationsListProps extends React.ComponentPropsWithoutRef<'div'> {
  notifications: NotificationDto[];
}

export const DashboardNotificationsList = (props: DashboardNotificationsListProps) => {
  const { notifications, className, ...rest } = props;

  return (
    <div className={cn('flex flex-col gap-4', className)} {...rest}>
      {notifications.map((notification) => (
        <NotificationsListItem notification={notification} key={notification.id} />
      ))}
    </div>
  );
};
